import { Role } from "@/types";
import { IDataProvider } from "@/store";

export enum TransferAuthorityTypes {
  FULL = "FULL",
  PARTIAL = "PARTIAL",
}

export enum TransferAuthorityUserTypes {
  USER = "USER",
  IOUSER = "IOUSER",
}

export enum TransferAuthorityStatuses {
  CLOSED = "CLOSED",
  WAIT_CONFIRM = "WAIT_CONFIRM",
  ACTIVE = "ACTIVE",
  DENIED = "DENIED",
}

export interface ITransferAuthority {
  userId: string;
  type: TransferAuthorityTypes;
  reason: string;
  startedAt: Date;
  expiredAt: Date;
}

export interface ITransferAuthorityState {
  transferAuthority: ITransferAuthority | null;
  transferAuthorities: ITransferAuthority[] | null;
  dataProvider: IDataProvider<ITransferAuthority>;
}

export const state: ITransferAuthorityState = {
  transferAuthority: null,
  transferAuthorities: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
